<ng-container [ngSwitch]="field?.type" *ngIf="field?.popUpConfig?.formId != 'TREATMENTS_EDITOR' || !previewMode">
    <gen-therapy-tier *ngSwitchCase="'tier'"
                      class="list-tier small-sizing" [hideLabel]="true"
                      [tier]="value"
    ></gen-therapy-tier>

    <div class="small-sizing" *ngSwitchCase="'include_in_report'">
        <i class="fa in-report-indication"
           [ngClass]="{
             'in-report fa-eye':subject?.visible.report,
             'fa-eye-slash':subject?.visible.report === false,
             'fa-circle-o-notch loading':(subject !== undefined && subject?.visible.report === null),
             'disabled':!subjectsAppearance?.showInToggleActive.report || subject?.mandatory.report || subjectsAppearance?.includeInDisabled.report
           }"
           (click)="changeIncludeIn('report', $event)"></i>
    </div>

    <div class="small-sizing" *ngSwitchCase="'include_in_report_toggle'">
        <p-checkbox
          [ngModel]="subject?.visible.report"
          [binary]="true"
          [disabled]="!subjectsAppearance.showInToggleActive.report || subject?.mandatory.report || subjectsAppearance?.includeInDisabled.report"
          [label]="field?.label | stringTranslate"
          (onChange)="changeIncludeIn('report', $event)"
        ></p-checkbox>
    </div>

    <div  class="small-sizing" *ngSwitchCase="'include_in_mi_toggle'">
        <p-checkbox
          *ngIf="subjectsAppearance?.isMDA"
          [ngModel]="subject?.visible.MI || MolecularFindingResource()"
          [binary]="true"
          [disabled]="MolecularFindingResource() || isUserCanChooseAberrationToMI() || !subjectsAppearance?.showInToggleActive.MI || subject?.mandatory.MI || subjectsAppearance?.includeInDisabled.MI"
          [label]="field?.label | stringTranslate"
          (onChange)="changeIncludeIn('MI', $event)"
        ></p-checkbox>
    </div>

    <ng-container *ngIf="editVisible">
      <gen-button *ngSwitchCase="'edit'"
                  [disabled]="isEditDisabled()"
                  [iconClass]="'icon__edit inline-edit-btn'"
                  [type]="'quite'"
                  class="edit-cell"
                  minPadding="true"
                  (click)="openEditTherapy()"
      ></gen-button>
    </ng-container>

    <span class="list-text counter small-sizing" *ngSwitchCase="'counter'">{{(value | async)?.length}}</span>

    <ng-container *ngSwitchCase="'textual_content'">
        <gen-textual-content
                [checkBlank]="true"
                [item]="value"
                [fieldConfig]="field.conf"
        ></gen-textual-content>
    </ng-container>

    <gen-dynamic-form-table *ngSwitchCase="'table'"
                            [showTitlesIfEmpty]="field.conf.showTitlesIfEmpty!==false"
                            [emptyMessageDisplay]="field.conf.emptyMessageDisplay || ''"
                            [uniqueBy]="field.conf.uniqueBy"
                            [disabled]="field.conf.disabled"
                            [editMode]="field.conf.editMode"
                            [formId]="field.conf.formId"
                            [data]="value"
    ></gen-dynamic-form-table>

    <gen-dynamic-form *ngSwitchCase="'form'"
                      [disabled]="field?.conf.disabled"
                      [editMode]="field?.conf.editMode"
                      [formName]="field?.conf.formId"
                      [listenToDataChange]="false"
                      [required]="false"
                      [formItemFullWidth]="field?.conf.formFullWidth"
                      [formData]="value"
    ></gen-dynamic-form>

    <ng-container *ngSwitchDefault>
        <span class="list-text"
              genEllipsis
              genTooltip
              [tooltipPosition]="'TOP'"
              [tooltipText]="value"
              [tooltipShow]="tooltipStatus"
              [reapply]="shouldApplyEllipsis()"
              (reapplyChange)="ellipsisApplyChange($event)"
              (tooltipStateEmit)="updateTooltipStatus($event)"
              *ngIf="value?.length">{{value}}</span>
    </ng-container>

  <ng-container *ngSwitchCase="'indicator-icon-column'">
    <div *ngIf="displayIcon()" class={{tooltipArr[tooltipArr.length-1]}}>
      <div class="icon" title={{tooltip}} >
        <span>{{icon}}</span>
      </div>
    </div>
  </ng-container>

</ng-container>


